import { PaymentList } from '@/models/api/payment/payment'
import { PaymentType } from '@/models/app-config/behavior/types'
import {
  PaymentInitializationSpec,
  ResultPaymentInitializationSpec,
} from '@spa/components/pages/order/model/payment/initialization/specification'
import * as E from 'fp-ts/lib/Either'
import * as O from 'fp-ts/lib/Option'

export class UseSpecifiedPaymentByQuery implements PaymentInitializationSpec {
  public static fromLocation(
    loc: Pick<Location, 'href'>,
    availablePaymentList: PaymentList
  ): PaymentInitializationSpec {
    return new UseSpecifiedPaymentByQuery(
      new URL(loc.href),
      availablePaymentList
    )
  }
  private static readonly paymentQuery = 'payment'

  private constructor(
    private readonly url: URL,
    private availablePaymentList: PaymentList
  ) {}

  async build(): Promise<ResultPaymentInitializationSpec> {
    const paymentType =
      this.url.searchParams.get(UseSpecifiedPaymentByQuery.paymentQuery) as PaymentType | null
    if (!paymentType) {
      return E.right(O.none)
    }

    return O.fromNullable(
      this.availablePaymentList.find(payment => payment.id === paymentType)
    ).fold<ResultPaymentInitializationSpec>(
      E.left(new Error(`${paymentType} is not available`)),
      (payment) => {
        switch (paymentType) {
          case 'amazon-pay-one-time':
            // 仮
            return E.right(O.some({ payment_type: 'amazon-pay-one-time', apiPayment: payment }))
          default:
            // 必要に応じてサポートを広げる
            // https://github.com/my-color/front/issues/4300 の対応時点ではAmazon Payのみ
            return E.right(O.none)
        }
      }
    )
  }
}
